import GoogleMapBaseStyle, { labels } from './GoogleMapBaseStyle';

const GoogleMapRoadmapWithPOIOnStyle = [
  ...GoogleMapBaseStyle,
  {
    featureType: 'administrative.land_parcel',
    elementType: 'labels',
    stylers: [ {
      visibility: 'off',
    } ],
  },
  {
    featureType: 'poi',
    stylers: [ {
      visibility: 'on',
    } ],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [ {
      visibility: 'off',
    } ],
  },
  {
    featureType: 'poi.attraction',
    elementType: 'labels.icon',
    stylers: [ {
      color: '#799db0',
    } ],
  },
  {
    featureType: 'poi.attraction',
    elementType: 'labels.text.fill',
    stylers: [ {
      color: labels,
    } ],
  },
  {
    featureType: 'poi.business',
    elementType: 'labels.icon',
    stylers: [ {
      color: '#799db0',
    } ],
  },
  {
    featureType: 'poi.business',
    elementType: 'labels.text.fill',
    stylers: [ {
      color: labels,
    } ],
  },
  {
    featureType: 'poi.government',
    elementType: 'labels.icon',
    stylers: [ {
      color: '#799db0',
    } ],
  },
  {
    featureType: 'poi.government',
    elementType: 'labels.text.fill',
    stylers: [ {
      color: labels,
    } ],
  },
  {
    featureType: 'poi.medical',
    elementType: 'labels.icon',
    stylers: [ {
      color: '#d4684b',
    } ],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [ {
      color: '#e1e2d9',
    },
    {
      visibility: 'on',
    } ],
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.icon',
    stylers: [ {
      color: '#7bb775',
    } ],
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',
    stylers: [ {
      color: labels,
    } ],
  },
  {
    featureType: 'poi.place_of_worship',
    elementType: 'labels.icon',
    stylers: [ {
      color: '#799db0',
    } ],
  },
  {
    featureType: 'poi.place_of_worship',
    elementType: 'labels.text.fill',
    stylers: [ {
      color: labels,
    } ],
  },
  {
    featureType: 'poi.school',
    elementType: 'labels.icon',
    stylers: [ {
      color: '#799db0',
    } ],
  },
  {
    featureType: 'poi.school',
    elementType: 'labels.text.fill',
    stylers: [ {
      color: labels,
    } ],
  },
  {
    featureType: 'poi.sports_complex',
    elementType: 'labels.icon',
    stylers: [ {
      color: '#799db0',
    } ],
  },
  {
    featureType: 'poi.sports_complex',
    elementType: 'labels.text.fill',
    stylers: [ {
      color: labels,
    } ],
  },
];

export default GoogleMapRoadmapWithPOIOnStyle;
